export type GatewayItem = {
    gatewayId: number;
    name: string;
}
export enum Gateway {
    behpardakht = 1,
    fanava = 2
}